module.exports = __webpack_public_path__ + "img/attachments.d14d60f9.svg";